"use strict";
import React from "react";
import _ from "underscore";
import Account from "../../api/account";
import LoadTable from "./load_table";
import LoadSearchForm from "./load_search_form";
import CarrierName from "../carrier_name";
export default React.createClass({
  getInitialState: function() {
    return { loads: [], searched: false };
  },
  onSearch: function(terms) {
    this.setState({ searching: true });
    this.props.searcher(terms).then((data) => {
      this.setState({
        searching: false,
        loads: data.loads,
        fell_back_to_any_carrier: data.fell_back_to_any_carrier,
        searched: true
      });
    });
  },
  onCancel: function() {
    this.setState({ searching: false, loads: [] });
    this.props.onCancel();
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "load-assigner__search-area" }, this.possibleLoadMessage(), /* @__PURE__ */ React.createElement("p", { className: "load-assigner__search-instructions" }, "Search for loads to assign."), /* @__PURE__ */ React.createElement(
      LoadSearchForm,
      {
        carrier: this.props.carrier,
        searching: this.state.searching,
        onSearch: this.onSearch,
        onCancel: this.onCancel
      }
    ), this.loadTable());
  },
  maybeShowAllCarrierNotification: function() {
    if (this.state.fell_back_to_any_carrier) {
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box--highlight" }, "No matches found for ", /* @__PURE__ */ React.createElement(CarrierName, { carrierID: this.props.carrier.id }), ", searching all ", Account.carrierTermLower(), "s.");
    }
  },
  loadTable: function() {
    if (!_.isEmpty(this.state.loads) || this.state.searched) {
      return /* @__PURE__ */ React.createElement("div", { className: "load-assigner__search-results" }, this.maybeShowAllCarrierNotification(), /* @__PURE__ */ React.createElement("h3", null, "Search Results"), /* @__PURE__ */ React.createElement(
        LoadTable,
        {
          items: this.state.loads,
          loadsNotFromEmailCarrier: this.props.loadsNotFromEmailCarrier,
          selectedLoadStateId: this.props.selectedLoadStateId,
          highlightedLoads: this.props.highlightedLoads,
          onSelectionChange: this.props.onSelectionChange,
          highlightChanged: this.props.highlightReference
        }
      ));
    }
  },
  possibleLoadMessage: function() {
    var message;
    if (this.props.multiCarrier) {
      message = `We couldn't find any loads in this document. First, use the search below to look for loads or click "Create an exception" below to report a problem. Next, assign a ` + Account.carrierTermLower() + ".";
    } else {
      message = `We couldn't find any loads in this document. Use the search below to look for loads or click "Create an exception" below to report a problem.`;
    }
    if (this.props.highlightedLoads.length === 0) {
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box--progress" }, message);
    }
  }
});
